import axios from 'axios'

const API_BASE = (process.env.VUE_APP_NOTIFICATION_API || 'https://web-backend.eae.international/notification-api').replace(/\/$/, '')
const WS_URL = process.env.VUE_APP_NOTIFICATION_WS || 'wss://web-backend.eae.international/notification-ws'

function authorization(token) {
  return { Authorization: `Bearer ${token}` }
}

export function getNotificationEvents(token, params = {}) {
  return axios.get(`${API_BASE}/events`, {
    headers: authorization(token),
    params,
    timeout: 15000
  })
}

export function getNotificationFilters(token) {
  return axios.get(`${API_BASE}/filters`, {
    headers: authorization(token),
    timeout: 15000
  })
}

export function createNotificationSocket() {
  return new WebSocket(WS_URL)
}
